import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { BORDER_ADJUSTMENT } from 'constants/nodeConnectors'
import { DropdownMenu } from 'components/patterns'

const getPathStyles = (props) => {
  const { isSimulating, nodeCarryEvaluation } = props
  if (!isSimulating) {
    return ''
  }
  if (nodeCarryEvaluation) {
    return `stroke: ${themeColor('confirmPrimary', props)};
    stroke-width: 2px;`
  }
  return `stroke: ${themeColor('errorPrimary', props)};
  stroke-width: 2px;
  stroke-dasharray: 5,5;
  `
}

export const StyledCircle = styled.circle`
  fill: ${themeColor('confirmPrimary')};
`

export const StyledConnectingGraph = styled.svg((props) => {
  const { carryAboveRung, topValue, height, theme } = props

  const topLineUp = topValue - height
  return `
    pointer-events: none;
    position: absolute;
    overflow: visible !important;
    transform: translateX(-100%);
    left: 0;
    top: ${(carryAboveRung ? topLineUp : topValue - BORDER_ADJUSTMENT) || 0}px;
    z-index: -1;
    path {
      fill: none;
      stroke: ${theme.featureConnectorLines};
      ${getPathStyles(props)}
    }
  `
})

export const StyledCricleDiv = styled.div`
  width: 22px;
  font-size: 16px;
  height: 22px;
  border-radius: 50px;
  border: solid 1px ${themeColor('slateLight')};
  background-color: ${themeColor('whitePrimary')};
  color: ${themeColor('bluePrimary')};
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    border-color: ${themeColor('blueAccent')};
    color: ${themeColor('blueAccent')};
    svg path {
      fill: ${themeColor('blueAccent')};
    }
  }

  &:active {
    border-color: ${themeColor('blueSecondary')};
    color: ${themeColor('whitePrimary')};
    svg path {
      fill: ${themeColor('whitePrimary')};
    }
  }

  .ant-dropdown-open & {
    border-color: ${themeColor('blueSecondary')};
    background: ${themeColor('blueSecondary')};
    color: ${themeColor('whitePrimary')};
    svg path {
      fill: ${themeColor('whitePrimary')};
    }
  }
`

export const StyledDropdown = styled(DropdownMenu)`
  cursor: pointer;
`
